import { z } from "zod";

export const createCoachSchema = z.object({
  user_id: z.string().min(1, "User ID is required"),
  boksmart_number: z.string().max(50).nullable().optional(), // 148
});

export type CreateCoachInput = z.infer<typeof createCoachSchema>;

// 148 -- update a coach's editable fields (currently just BokSmart number)
export const updateCoachSchema = z.object({
  boksmart_number: z.string().max(50).nullable().optional(),
});

export type UpdateCoachInput = z.infer<typeof updateCoachSchema>;
